import Raven from "raven-js"

import config from "core/config"

export const startRavenJS = () => {
  if (config.env !== "production") return
  Raven
    .config(config.sentry)
    .install()
}

export default {
  startRavenJS,
}



// WEBPACK FOOTER //
// ./src/shared/services/analytics.js